<template>
  <div
    class="element-manage-container"
    v-if="isPageVisible">
    <DragPanel v-show="catalogTreeVisible">
      <CatalogTree
        :width="260"
        ref="catalogTree"
        type="PrivateElem"
        :userId="filterUser"
        :data="catalogData"
        :updateData="updateData"
        :nodeClick="handleNodeClick"
        :hideCatalogTree="hideCatalogTree" />
    </DragPanel>
    <!-- <div v-if="!catalogTreeVisible" class="collapse-icon-box">
      <icon-svg
        icon-class="ic-ico_an"
        class="icon"
        title="展开目录树"
        @click.native="openCatalogTree"
      />
    </div> -->
    <div class="elements-box outer-page-primary">
      <div
        :class="`head-box header-box ${
          isSuperMap() ? 'supermap-header-box' : ''
        }`">
        <Breadcrumb
          :breadcrumbList="breadcrumbList"
          :breadcrumbClick="breadcrumbClick" />
        <div class="common-button-box">
          <el-button
            class="normal-btn"
            size="small"
            @click="openUploadDialog"
            v-if="isChecked('Project.ComponentLibrary.Private.Upload')">
            <div class="icon-box">
              <icon-svg
                icon-class="icon-shangchuanliebiao"
                class="icon" />
              <span>上传列表</span>
            </div>
          </el-button>
          <el-button
            class="normal-btn"
            size="small"
            @click="openQueueDialog"
            v-if="isChecked('Project.ComponentLibrary.Private.Upload')">
            <div class="icon-box">
              <icon-svg
                icon-class="icon-zhuanhuanduilie"
                class="icon" />
              <span>转换队列</span>
            </div>
          </el-button>
          <el-button
            size="small"
            type="text"
            title="切换视图"
            @click="switchMode">
            <div class="icon-box changeView">
              <icon-svg
                v-if="viewMode === 'card'"
                icon-class="icon-liebiaoshitu1"
                class="icon" />
              <icon-svg
                v-if="viewMode === 'table'"
                icon-class="icon-suolvetushitu"
                class="icon" />
            </div>
          </el-button>
        </div>
      </div>
      <div class="operation-box">
        <div class="common-button-box btn-group-primary">
          <el-button
            v-if="
              isSuperMap() &&
              isChecked('Project.ComponentLibrary.Private.Upload')
            "
            key="uploadBtn"
            size="small"
            class="upload-btn primary-btn"
            id="element-upload"
            @click="uploadFile">
            上传
          </el-button>
          <el-button
            v-if="
              !isSuperMap() &&
              isChecked('Project.ComponentLibrary.Private.Upload')
            "
            key="uploadBtn"
            type="primary"
            size="small"
            class="upload-btn primary-btn"
            id="element-upload"
            @click="uploadFile">
            上传
          </el-button>
          <div class="gl16 common-dropdown-box">
            <el-dropdown
              placement="bottom-start"
              :append-to-body="false"
              @command="batchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量操作 <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item command="1">下载</el-dropdown-item>
                <el-dropdown-item
                  command="2"
                  v-if="
                    isChecked('Project.ComponentLibrary.Private.BatchDelete')
                  ">
                  删除
                </el-dropdown-item>
                <el-dropdown-item
                  command="3"
                  v-if="
                    isChecked('Project.ComponentLibrary.Private.BatchMove')
                  ">
                  移动到
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="filter-box">
          <div
            class="filter-item-box"
            v-if="isSuperAdmin()">
            <div class="label searchLabel">用户</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                v-model="filterUser"
                size="small"
                filterable
                remote
                :remote-method="queryUserList"
                :popper-append-to-body="false"
                popper-class="common-select-dropdown"
                @change="switchUserValue">
                <div v-infinite-scroll="handleScroll">
                  <el-option
                    v-for="(item, index) in userList"
                    :key="index"
                    :label="item.surname"
                    :value="item.userId" />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label searchLabel">排序</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                v-model="sortValue"
                size="small"
                @change="switchSortValue"
                :popper-append-to-body="false"
                popper-class="common-select-dropdown">
                <el-option
                  value="LastUsedDate"
                  label="最近使用" />
                <el-option
                  value="UsageCount"
                  label="使用次数" />
                <el-option
                  value="UploadTime"
                  label="上传时间" />
                <el-option
                  value="MostFavorites"
                  label="收藏最多" />
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="keywords"
                placeholder="请输入模型名称"
                clearable
                @clear="search"
                @keyup.enter.native="search">
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search icon"
                  @click="search" />
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="element-list-box">
        <CardList
          ref="cardList"
          v-if="viewMode === 'card'"
          :initCatalog="initCatalog"
          :elemUploader="elemUploader"
          :currNode="selectedNode"
          :filterUser="filterUser"
          :sortValue="sortValue"
          :keywords="keywords"
          :openMoveDialog="openMoveDialog"
          :openThumbnailDialog="openThumbnailDialog" />
        <TableList
          ref="tableList"
          v-if="viewMode === 'table'"
          :initCatalog="initCatalog"
          :elemUploader="elemUploader"
          :currNode="selectedNode"
          :filterUser="filterUser"
          :sortValue="sortValue"
          :keywords="keywords"
          :openMoveDialog="openMoveDialog" />
      </div>
    </div>
    <MoveDialog
      :visible="moveDialogVisible"
      type="PrivateElem"
      :userId="filterUser"
      :currNode="selectedNode"
      :elemsToMove="elemsToMove"
      :initCatalog="initCatalog"
      :updateDataList="updateDataList"
      :closeDialog="closeMoveDialog" />
    <ThumbnailDialog
      :visible="thumbnailDialogVisible"
      type="PrivateElem"
      :elemInfo="elemToUpdateImg"
      :updateDataList="updateDataList"
      :closeDialog="closeThumbnailDialog" />
    <ElemUploadList
      :visible="uploadListVisible"
      type="PrivateElem"
      :elemUploader="elemUploader"
      :closeDialog="closeUploadDialog" />
    <MiniElemUploadList
      :elemUploader="elemUploader"
      type="PrivateElem" />
    <ElemQueue
      :visible="queueVisible"
      type="PrivateElem"
      :userId="filterUser"
      :closeDialog="closeQueueDialog" />
  </div>
</template>

<script>
import DragPanel from '@/components/DragPanel.vue'
import CatalogTree from './components/CatalogTree.vue'
import Breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import CardList from './privateElement/CardList.vue'
import MoveDialog from './components/MoveDialog.vue'
import ThumbnailDialog from './components/ThumbnailDialog.vue'
import TableList from './privateElement/TableList.vue'
import ElemQueue from './components/ElemQueue.vue'
import ElemUploadList from './components/ElemUploadList.vue'
import MiniElemUploadList from './components/MiniElemUploadList.vue'

import ElemUploader from '@/utils/elemUploader'
import { Store } from '@/utils/store'
import { getParentNode } from '@/utils/generalMethods'

import {
  getClientTokenService,
  getRoleMenu,
  getUserNameList,
  privateElemCatalogService,
  privateElemFileListService,
  privateElemBatchPauseUploadService
} from '@/service/interface'

export default {
  data() {
    return {
      isPageVisible: false,

      catalogTreeVisible: true,
      catalogRootId: '00000000-0000-0000-0000-000000000000',
      catalogData: [],
      breadcrumbList: [],
      viewMode: 'card',
      selectedNode: {},

      filterUser: '',
      userList: [],
      currentPage: 1,
      pageSize: 100,
      username: '',
      allUserLoaded: false,

      sortValue: 'LastUsedDate',
      keywords: '',

      moveDialogVisible: false,
      elemsToMove: [],

      thumbnailDialogVisible: false,
      elemToUpdateImg: {},

      uploadListVisible: false,
      queueVisible: false
    }
  },
  components: {
    DragPanel,
    CatalogTree,
    Breadcrumb,
    CardList,
    MoveDialog,
    ThumbnailDialog,
    TableList,
    ElemQueue,
    ElemUploadList,
    MiniElemUploadList
  },
  mounted() {
    this.initClientInfo().then(() => {
      this.isPageVisible = true

      this.initUserList()
      this.initUploader()
      this.pauseFilesUpload()

      this.initCatalog().then(() => {
        let nodeData = this.catalogData[0]
        let node = this.$refs.catalogTree.getNode(nodeData.nodeId)
        this.handleNodeClick(nodeData, node)
      })

      this.elemUploader.on('uploadFinish', this.onUploadFinish)
    })

    window.addEventListener('unload', this.onUnLoad)
  },
  beforeDestroy() {
    this.elemUploader.off('uploadFinish', this.onUploadFinish)
  },
  methods: {
    initClientInfo() {
      return new Promise(resolve => {
        if (window.isClientAuthByConfig) {
          this.initClientToken().then(() => {
            this.initClientPermission().then(() => {
              resolve()
            })
          })
        } else {
          resolve()
        }
      })
    },
    initClientToken() {
      return new Promise(resolve => {
        let params = {
          clientId: window.clientId,
          secretKey: window.secretKey,
          userId: window.userId
        }
        getClientTokenService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', response.token)
              sessionStorage.setItem('tokenId', response.tokenId)
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    initClientPermission() {
      return new Promise(resolve => {
        let params = { menuName: '' }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let response = res.data
            if (response.isSuccess) {
              let permissionData = response.data
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resolve(permissionData)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    initUploader() {
      let uploaders = Store.uploaders
      let find = uploaders.find(el => el.schemeType === 'CLPrivateDoc')
      if (find) {
        this.elemUploader = find.uploader
        this.elemUploader.setCurrNodeId('')
        this.elemUploader.setUploadPathName('')
      } else {
        this.elemUploader = new ElemUploader('CLPrivateDoc')
      }
    },
    onUnLoad() {
      sessionStorage.setItem('pauseFlag', false)
    },
    pauseFilesUpload() {
      if (!this.isChecked('Project.ComponentLibrary.Private.Upload')) return

      let params = {
        resultCount: 1000,
        skipCount: 0,
        name: '',
        status: [1]
      }
      privateElemFileListService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let uploadingList = data.items

          uploadingList = uploadingList.filter(el => el.isMineUpload)
          let filesToPause = uploadingList.map(fileInfo => {
            let obj = {
              fileId: fileInfo.fileId,
              fileDataId: fileInfo.id
            }
            return obj
          })
          if (filesToPause.length) {
            this.batchPauseFiles(filesToPause)
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchPauseFiles(filesToPause) {
      let formData = new FormData()
      let FileIds = filesToPause.map(el => el.fileId)
      let FileDataIds = filesToPause.map(el => el.fileDataId)
      formData.append('FileIds', FileIds)
      formData.append('FileDataIds', FileDataIds)
      privateElemBatchPauseUploadService(formData).then(response => {
        if (response.isSuccess) {
          sessionStorage.setItem('pauseFlag', true)
        }
      })
    },
    initUserList() {
      if (this.isSuperAdmin()) {
        let params = {
          maxResultCount: 100,
          skipCount: 0,
          searchType: 'surname',
          filter: ''
        }
        getUserNameList(params).then(response => {
          if (response.status === 200) {
            let result = response.data
            if (result.isSuccess) {
              let userList = result.data.items
              this.userList = userList

              let userInfo = Store.userInfo
              this.filterUser = userInfo.userId
              this.catalogTreeVisible = true
            }
          }
        })
      } else {
        this.catalogTreeVisible = true
      }
    },
    initCatalog() {
      return new Promise(resolve => {
        let userInfo = Store.userInfo
        let userId = this.filterUser ? this.filterUser : userInfo.userId
        let params = {
          parentId: this.catalogRootId,
          userId: userId,
          returnCount: true,
          lazyLoading: false
        }
        privateElemCatalogService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let catalogData = [
              {
                nodeId: this.catalogRootId,
                nodeName: '我的构件',
                nodeType: { value: 0, displayName: '根节点' },
                count: data.count,
                nodes: data.nodes
              }
            ]
            this.catalogData = catalogData
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    openQueueDialog() {
      this.queueVisible = true
    },
    closeQueueDialog() {
      this.queueVisible = false
    },
    switchUserValue() {
      this.initCatalog().then(() => {
        this.updateDataList()
      })
    },
    switchSortValue() {
      this.updateDataList()
    },
    openCatalogTree() {
      if (this.isSuperAdmin() && !this.filterUser) {
        this.$message.warning('请先选择用户')
        return
      }

      this.catalogTreeVisible = true
    },
    hideCatalogTree() {
      this.catalogTreeVisible = false
    },
    handleNodeClick(nodeData, node) {
      if (nodeData.nodeId === this.selectedNode.nodeId) return

      this.$refs.catalogTree.setCurrentKey(nodeData.nodeId)
      this.selectedNode = nodeData

      this.breadcrumbList = this.getBreadCrumbList(node)

      this.clearFilter()
      this.updateDataList()

      this.$nextTick(() => {
        this.initUploadBtn()

        let uploadPathName = this.getUploadPathName()
        this.elemUploader.setCurrNodeId(this.selectedNode.nodeId)
        this.elemUploader.setUploadPathName(uploadPathName)
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('element-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.elemUploader.uploader.addButton({ id: '#element-upload' })
        }
      }
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      let selectData = this.findNodeById(this.catalogData, data.id)
      let node = this.$refs.catalogTree.getNode(selectData.nodeId)
      this.handleNodeClick(selectData, node)
    },
    switchMode() {
      this.clearFilter()

      if (this.viewMode === 'card') {
        this.viewMode = 'table'
      } else {
        this.viewMode = 'card'
      }
    },
    uploadFile() {
      this.elemUploader.setStatus('waiting')
    },
    onUploadFinish() {
      this.initCatalog().then(() => {
        let nodeId = this.selectedNode.nodeId
        this.$refs.catalogTree.setCurrentKey(nodeId)
        this.updateDataList()
      })
    },
    batchOperate(command) {
      let dom = this.$refs[`${this.viewMode}List`]
      switch (command) {
        case '1':
          dom.batchDownloadElem()
          break
        case '2':
          dom.batchDeleteElement()
          break
        case '3':
          dom.batchMoveNode()
          break
      }
    },
    search() {
      this.updateDataList()
    },
    openMoveDialog(datas) {
      this.elemsToMove = datas
      this.moveDialogVisible = true
    },
    closeMoveDialog() {
      this.elemsToMove = []
      this.moveDialogVisible = false
    },
    openThumbnailDialog(data) {
      this.elemToUpdateImg = data
      this.thumbnailDialogVisible = true
    },
    closeThumbnailDialog() {
      this.elemToUpdateImg = {}
      this.thumbnailDialogVisible = false
    },
    openUploadDialog() {
      this.uploadListVisible = true
    },
    closeUploadDialog() {
      this.uploadListVisible = false
    },
    updateDataList() {
      this.$nextTick(() => {
        if (this.viewMode === 'card') {
          this.$refs.cardList.initDataList()
        } else {
          this.$refs.tableList.initDataList()
        }
      })
    },
    updateData(nodeId) {
      return new Promise(resolve => {
        this.initCatalog().then(() => {
          let nodeData = this.findNodeById(this.catalogData, nodeId)
          if (nodeData) {
            let node = this.$refs.catalogTree.getNode(nodeId)
            this.handleNodeClick(nodeData, node)
          } else {
            let nodeData = this.catalogData[0]
            let node = this.$refs.catalogTree.getNode(nodeData.nodeId)
            this.handleNodeClick(nodeData, node)
          }
          resolve()
        })
      })
    },
    updateThumbnail() {},
    clearFilter() {
      this.sortValue = 'LastUsedDate'
      this.keywords = ''
    },
    queryUserList(username) {
      this.currentPage = 1
      this.allUserLoaded = false
      this.username = username
      let params = {
        maxResultCount: 100,
        skipCount: 0,
        searchType: 'surname',
        filter: this.username
      }
      getUserNameList(params).then(response => {
        if (response.status === 200) {
          let result = response.data
          if (result.isSuccess) {
            let userList = result.data.items
            this.userList = userList
          }
        }
      })
    },
    handleScroll() {
      if (this.allUserLoaded) return
      this.currentPage++
      let params = {
        maxResultCount: this.pageSize,
        skipCount: (this.currentPage - 1) * this.pageSize,
        searchType: 'surname',
        filter: this.username
      }
      getUserNameList(params).then(response => {
        if (response.status === 200) {
          let result = response.data
          if (result.isSuccess) {
            let userList = result.data.items
            if (userList.length) {
              this.userList = [...this.userList, ...userList]
            } else {
              this.allUserLoaded = true
            }
          } else {
            this.$message.error(result.errMsg)
          }
        }
      })
    },
    getBreadCrumbList(node) {
      let parentNodes = []
      this.getParentNode(node, parentNodes)
      parentNodes.reverse()
      let breadcrumbList = []
      parentNodes.forEach(item => {
        let nodeData = item.data
        let nodeType = nodeData.nodeType.value
        let obj = {
          id: nodeData.nodeId,
          name: nodeType === 0 ? '全部' : nodeData.nodeName,
          isElement: true
        }
        breadcrumbList.push(obj)
      })
      return breadcrumbList
    },
    getUploadPathName() {
      let uploadPathName = ''
      let tempArray = this.breadcrumbList.map((item, index) => {
        if (index === 0) {
          return '我的构件'
        } else {
          return item.name
        }
      })
      uploadPathName = tempArray.join('/')
      return uploadPathName
    },
    findNodeById(data, id) {
      for (const node of data) {
        if (node.nodeId === id) return node
        if (node.nodes && node.nodes.length) {
          const res = this.findNodeById(node.nodes, id)
          if (res) return res
        }
      }
      return null
    },
    isSuperAdmin() {
      return this.isChecked('Project.ComponentLibrary.Private.UserFilter')
    },
    isSuperMap() {
      let path = this.$route.path
      if (path.includes('supermap')) {
        return true
      } else {
        return false
      }
    },
    treeToList(permissionData) {
      let queue = []
      let out = []
      queue = queue.concat(permissionData)
      while (queue.length) {
        let first = queue.shift()
        if (first.childNodes) {
          queue = queue.concat(first.childNodes)
          delete first['childNodes']
        }
        out.push(first)
      }
      return out
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
// .common-drag-panel {
//   /deep/ .content {
//     width: 260px;
//   }
// }
.element-manage-container {
  display: flex;
  height: 100%;

  .collapse-icon-box {
    position: absolute;
    margin-left: -10px;
    margin-top: -10px;
    height: 32px;
    background: var(--icon-bg-color2);
    z-index: 2;
    padding: 5px;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      color: var(--primary-color);
    }
  }

  .elements-box {
    position: relative;
    flex-grow: 1;
    border-radius: 16px;

    .head-box {
      display: flex;
      justify-content: space-between;

      .common-button-box {
        display: flex;
        align-items: center;
        // .el-button {
        //   margin-right: 0px;
        //   padding: 0px 10px;
        // }

        // .el-button--text {
        //   color: var(--default-color);
        //   margin-left: 5px;
        //   padding: 0px;
        // }

        .icon-box {
          display: flex;
          font-size: 14px;

          .icon {
            font-size: 20px;
            margin: -2px 5px;
          }
        }

        .changeView {
          .icon {
            color: var(--privateElement-page-search-icon-color);
            &:hover {
              color: var(--base-primary-bgColor);
            }
          }
        }
      }
    }

    .supermap-header-box {
      /deep/ .common-breadcrumb-box {
        .el-breadcrumb {
          .el-breadcrumb__item {
            &:last-child .el-breadcrumb__inner {
              color: var(--breadcrumb-color);
              border: 1px solid var(--header-bg-color);
              background: var(--breadcrumb-bg-color);
            }
          }
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: space-between;

      .common-button-box {
        display: flex;

        .upload-btn {
          padding: 0px 30px;
        }
      }

      .filter-box {
        display: flex;

        .filter-item-box {
          display: flex;
          margin-left: 20px;

          .label {
            line-height: 32px;
            margin-right: 10px;
          }

          .common-select-box {
            width: 120px;
            text-align: left;
          }
        }
      }
    }

    .element-list-box {
      height: calc(100% - 112px);
      margin-top: 10px;
      padding: 0 16px;
    }
  }
}
</style>
